import { asyncActionCreator } from '../../shared/redux/actions/common'
import { ADMIN_PROFILE_LOGO_DELETE, FETCH_MARKETS, FETCH_REPORTS, FETCH_TENANTS } from '../const'
import { sendJson, patchProperty, getJson } from '../../shared/utils/api'
import { config } from '../../config'
import { Tenant, TenantModel } from '../../shared/types/tenant';

interface PasswordInfo {
    currentPassword: string;
    newPassword: string;
}

export const updateAdmin = (tenantUserId: string, admin: TenantModel) => {
    return sendJson(`tenant/${tenantUserId}`, 'PATCH', [
        patchProperty('contact', admin.contact),
    ])
}

// need to be id of image
export const deleteLogo = (id: string) => {
    return asyncActionCreator(ADMIN_PROFILE_LOGO_DELETE, () => sendJson(`image/${id}`, 'DELETE'))
}

export const updatePassword = (passwordInfo: PasswordInfo) => {
    return sendJson(`tenant/password`, 'POST', passwordInfo)
}

// superadmin - loginy (TenantUserInfo) vsetkych tenantov, bez hesiel
export interface TenantUserInfo {
    id: string
    login: string
    tenantId: string
    tenantName?: string
}

export const fetchTenantUsers = (): Promise<TenantUserInfo[]> => {
    return getJson('tenant/users')
}

// superadmin - nastavenie hesla loginu bez zadania aktualneho (strateny pristup)
export const setTenantUserPassword = (tenantUserId: string, newPassword: string) => {
    return sendJson(`tenant/users/${tenantUserId}/password`, 'POST', { newPassword })
}

export const fetchTenants = () => {
    return asyncActionCreator(FETCH_TENANTS, () => getJson('tenant/all'))
}

export const fetchMarkets = () => {
    return asyncActionCreator(FETCH_MARKETS, () => getJson(`market/all`))
}

export const fetchReports = (tenantId: string) => {
    if (tenantId === config.mainTenantId) {
        return asyncActionCreator(FETCH_REPORTS, () => getJson(`report/all`))
    } else {
        return asyncActionCreator(FETCH_REPORTS, () => getJson(`report/${tenantId}`))
    }
}

// superadmin - sprava reportov (dashboard -> prehlad tenantov)
export interface ReportModel {
    id?: string
    name: string
    url: string
    description?: string | null
    tenantId?: string | null
}

export const addReport = (report: ReportModel): Promise<ReportModel> => {
    return sendJson('report', 'POST', report)
}

export const updateReport = (id: string, report: ReportModel): Promise<ReportModel> => {
    return sendJson(`report/${id}`, 'PUT', { ...report, id })
}

export const deleteReport = (id: string) => {
    return sendJson(`report/${id}`, 'DELETE')
}

// superadmin - sprava marketov (bez mazania - market pouzivaju lokality a ceny)
export interface MarketModel {
    id?: string
    name: string
    url?: string | null
    description?: string | null
}

export const addMarket = (market: MarketModel): Promise<MarketModel> => {
    return sendJson('market', 'POST', market)
}

export const updateMarket = (id: string, market: MarketModel): Promise<MarketModel> => {
    return sendJson(`market/${id}`, 'PUT', { ...market, id })
}

// sprava loginov (TenantUser) - superadmin vsetkych tenantov, ostatni admini len svojho tenanta
export const createTenantUser = (login: string, password: string, tenantId?: string): Promise<TenantUserInfo> => {
    return sendJson('tenant/users', 'POST', { login, password, tenantId })
}

export const renameTenantUser = (tenantUserId: string, login: string) => {
    return sendJson(`tenant/users/${tenantUserId}`, 'PUT', { login })
}

export const deleteTenantUser = (tenantUserId: string) => {
    return sendJson(`tenant/users/${tenantUserId}`, 'DELETE')
}

// zmena vlastneho loginu (kazdy admin)
export const renameOwnLogin = (login: string) => {
    return sendJson('tenant/me/login', 'PUT', { login })
}

// superadmin - kontakt lubovolneho tenanta
export const updateTenantContact = (tenantId: string, contact: string) => {
    return sendJson(`tenant/${tenantId}/contact`, 'PUT', { contact })
}

export const createTenant = (name: string, contact: string, adminLogin?: string, adminPassword?: string): Promise<Tenant> => {
    return sendJson('tenant', 'POST', { name, contact, adminLogin, adminPassword })
}
